import React, { useState } from "react";
import "./profile-popover.styles.scss";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import { createStructuredSelector } from "reselect";

import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import { ReactComponent as RightCornerSVG } from "../../assets/Vector 6.svg";
import { ReactComponent as LeftCornerSVG } from "../../assets/Vector 7.svg";
import { ReactComponent as LogoITC } from "../../assets/ITCLogoLogin.svg";
import { resetUser } from "../../redux/user/user.actions";
import { selectUserData } from "../../redux/user/user.selectors";

import { logoutService, changePwService } from "../../services/login-services";

import {
  message,
  Form,
  Input,
  Button,
  Avatar,
  Typography,
  Flex,
  Drawer,
} from "antd";
import { resetCommonReducer } from "../../redux/common/common.actions";
import triggerSleepClient from "../../services/timeout-services";
// import { encrypt } from "../../utils/utils";
import { encryptLoginField } from "../../security/loginCrypto";

const ProfilePopover: React.FC<any> = (props: any) => {
  const { userData, resetUserData, resetReducer } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const logoutFn = async () => {
    try {
      sessionStorage.clear();
      localStorage.clear();
      resetUserData();
      resetReducer();
      triggerSleepClient.stopTimers();
    } catch (error) {
      console.log(error);
      // message.warning("Cannot logout..!");
    }
  };

  const onFinish = async (values: {
    old_password: string;
    new_password: string;
    confirm_password: string;
  }) => {
    try {
      const euser_name = await encryptLoginField(userData.username);
      const eold_password = await encryptLoginField(values.old_password);
      const enew_password = await encryptLoginField(values.new_password);
      const dataToSend = {
        user_name: euser_name,
        old_password: eold_password,
        new_password: enew_password,
      };
      setLoading(true);

      const response = await changePwService(dataToSend);

      if (response.status === 200) {
        setModalVisible(false);
        form.resetFields();
        message.success("Password changed successfully..!");
        await logoutFn();
      } else {
        message.error("Cannot reset password..!");
      }
    } catch (error: any) {
      if (error.response?.data?.msg) {
        message.error(error.response?.data?.msg + " !!!");
      } else {
        message.error("Something went wrong...Please try again !!!");
      }
    }
    setLoading(false);
  };
  const onchange = async (e: any) => {
    if (
      e.target.value &&
      e.target.id.split("change_pw_")[1] === "old_password"
    ) {
      form.setFieldsValue({ old_password: e.target.value.replace(/\s/g, "") });
    }
    if (
      e.target.value &&
      e.target.id.split("change_pw_")[1] === "new_password"
    ) {
      form.setFieldsValue({ new_password: e.target.value.replace(/\s/g, "") });
    }
    if (
      e.target.value &&
      e.target.id.split("change_pw_")[1] === "confirm_password"
    ) {
      form.setFieldsValue({
        confirm_password: e.target.value.replace(/\s/g, ""),
      });
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="popover-container">
      <Drawer
        open={true}
        footer={false}
        onClose={() => {
          form.resetFields();
          setModalVisible(false);
        }}
        closable={false}
        size={"large"}
        width={"280vh"}
        // maskClosable={false}
        // className="forgot-pw-modal"
      >
        <div className="change-pw-modal">
          <RightCornerSVG
            style={{
              transform: "translate(-12%, 26%)",
              height: "30em",
              width: "14em",
            }}
          />
          <div className="reset">
            <div className="logo-container">{<LogoITC />}</div>
            <div
              className="header"
              style={{
                marginBlock: "30px 20px",
                fontSize: 30,
                textAlign: "center",
                color: "#123274",
              }}
            >
              Change Password
            </div>
            <Form
              form={form}
              name="change_pw"
              initialValues={{ remember: false }}
              size="large"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onChange={onchange}
            >
              <Form.Item
                style={{ marginBottom: 0, fontWeight: 700 }}
                name="old_password"
                rules={[
                  {
                    required: true,
                    message: "Please input password !",
                  },
                ]}
                label="Current Password"
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  //   type="password"
                  placeholder={"Current Password"}
                />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: 0, fontWeight: 700 }}
                name="new_password"
                dependencies={["old_password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please input password !",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("old_password") !== value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "The new password should not be same as current password !"
                      );
                    },
                  }),
                ]}
                label="New Password"
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  //   type="password"
                  placeholder={"New Password"}
                />
              </Form.Item>
              <Form.Item
                style={{ marginBottom: 0, fontWeight: 700 }}
                name="confirm_password"
                dependencies={["new_password"]}
                hasFeedback
                label="Confirm Password"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password !",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "Confirm password does not match with new password !"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  //   type="password"
                  placeholder={"Confirm Password"}
                />
              </Form.Item>
              <Form.Item>
                <div className="reset-btn-container">
                  <Button
                    loading={loading}
                    type="primary"
                    size={"large"}
                    block
                    htmlType="submit"
                    style={{ background: "#123274" }}
                  >
                    Reset Password
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
          <LeftCornerSVG
            style={{
              transform: "translate(12%, -35%)",
              height: "30em",
              width: "14em",
            }}
          />
        </div>
      </Drawer>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    resetReducer: () => dispatch(resetCommonReducer()),
    resetUserData: () => dispatch(resetUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePopover);
